import React from 'react';
import LegacyNavItem from '../../../views/components/Sidebar/LegacyNavItem';
import { useAppSelector } from '../../../redux-file/hooks';
import { useGhgOrganization } from '../../../common/hooks';
import { OrganizationTag, hasTag } from '../../../utils/tags';
import { useGhgSidebarPermissions } from 'src/Ghg/hooks';

export default function GhgScope3Items() {
  const organization = useGhgOrganization();
  const showTransportationSummary = hasTag(
    organization,
    OrganizationTag.TransportationSummary
  );

  const { selectedDate } = useAppSelector((state) => state.questionnaire);
  const { hasAccess } = useGhgSidebarPermissions(
    organization.id,
    selectedDate.getFullYear()
  );

  return (
    <>
      {hasAccess('scope_3', 'goods_and_services') && (
        <LegacyNavItem
          name="goods-and-services"
          path="emissions/questionnairepage-goods-and-services"
        />
      )}
      {hasAccess('scope_3', 'transportation_and_distribution') && (
        <LegacyNavItem
          name="indirect-transportations"
          path="emissions/questionnairepage-indirect-transportations"
          icon="indirect-emissions"
        />
      )}
      {showTransportationSummary && (
        <LegacyNavItem
          name="transportation-summary"
          path="emissions/transportation-summary"
          icon="indirect-emissions"
        />
      )}
      {hasAccess('scope_3', 'assets_franchises_investments') && (
        <LegacyNavItem
          name="assets"
          path="emissions/questionnairepage-assets"
        />
      )}
      {hasAccess('scope_3', 'waste_and_other_emissions') && (
        <LegacyNavItem
          name="waste-and-other"
          path="emissions/questionnairepage-waste-and-other"
        />
      )}
      {hasAccess('scope_3', 'emissions_of_sold_products') && (
        <LegacyNavItem
          name="sold-products"
          path="emissions/questionnairepage-sold-products"
        />
      )}
      {hasAccess('scope_3', 'employee_emissions') && (
        <LegacyNavItem
          name="employee-surveys"
          path="emissions/employees"
          icon="format"
        />
      )}
    </>
  );
}
